"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBIconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var polished_1 = require("polished");
var MBText_1 = require("../MBText");
var MBTooltip_1 = require("../MBTooltip");
/**
 * MeetButter IconButton
 * ---
 * Extended component of Material UI `IconButton`,
 * injected with theme.
 */
function MBIconButton(_a) {
    var Icon = _a.Icon, title = _a.title, tooltip = _a.tooltip, _b = _a.tooltipProps, tooltipProps = _b === void 0 ? {} : _b, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, disabled = _a.disabled, hoverCss = _a.hoverCss, props = __rest(_a, ["Icon", "title", "tooltip", "tooltipProps", "onClick", "onMouseEnter", "onMouseLeave", "disabled", "hoverCss"]);
    var iconProps = __assign({ size: 24 }, Icon.props);
    var handleClick = function (e) {
        /* this prevents page from refreshing if button is wrapped inside a form */
        if (props.type !== 'submit')
            e.preventDefault();
        !disabled && onClick && onClick(e);
    };
    var renderUI = function () {
        if (title) {
            return (jsx_runtime_1.jsxs(StyledIconButton, __assign({ onClick: handleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hover: hoverCss }, props, { children: [jsx_runtime_1.jsx(Icon.component, __assign({}, iconProps), void 0),
                    typeof title === 'string' ? (jsx_runtime_1.jsx(MBText_1.MBText, { variant: "labelTiny", t: title, mt: 0.5 }, void 0)) : (title)] }), void 0));
        }
        return (jsx_runtime_1.jsx(StyledIconButton, __assign({}, props, { onClick: handleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: jsx_runtime_1.jsx(Icon.component, __assign({}, iconProps), void 0) }), void 0));
    };
    if (tooltip) {
        return (jsx_runtime_1.jsx(MBTooltip_1.MBTooltip, __assign({ title: tooltip }, tooltipProps, { children: renderUI() }), void 0));
    }
    return renderUI();
}
exports.MBIconButton = MBIconButton;
var NormalizedButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // fix for Firefox & safari\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n\n  // fix for IE & Edge\n  overflow: visible;\n  text-transform: none;\n\n  // fix for iOS & Safari\n  -webkit-appearance: button;\n  border: none;\n  background: none;\n"], ["\n  // fix for Firefox & safari\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n\n  // fix for IE & Edge\n  overflow: visible;\n  text-transform: none;\n\n  // fix for iOS & Safari\n  -webkit-appearance: button;\n  border: none;\n  background: none;\n"])));
var StyledIconButton = styled_components_1.default(NormalizedButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  box-sizing: border-box;\n\n  border-radius: 4px;\n  cursor: ", ";\n  transition: 0.2s all ease-in-out;\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  border-radius: ", ";\n\n  color: inherit;\n\n  :hover {\n    ", "\n    background: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  box-sizing: border-box;\n\n  border-radius: 4px;\n  cursor: ", ";\n  transition: 0.2s all ease-in-out;\n  ",
    "\n  ",
    "\n  ",
    ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", "\n  ", "\n  ",
    "\n  border-radius: ",
    ";\n\n  color: inherit;\n\n  :hover {\n    ", "\n    background: ",
    ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var height = _a.height;
    return height
        ? Number.isInteger(height)
            ? "height: " + height + "px;"
            : "height: " + height + ";"
        : '';
}, function (_a) {
    var width = _a.width;
    return width
        ? typeof width === 'string'
            ? "width: " + width + ";"
            : "width: " + width + "px;"
        : '';
}, function (_a) {
    var _b = _a.padding, padding = _b === void 0 ? 1 : _b;
    return Number.isInteger(padding)
        ? "padding: " + Number(padding) * 8 + "px;"
        : "padding: " + padding;
}, function (_a) {
    var mr = _a.mr, theme = _a.theme;
    return mr && "margin-right: " + theme.spacing(mr) + "px";
}, function (_a) {
    var ml = _a.ml, theme = _a.theme;
    return ml && "margin-left: " + theme.spacing(ml) + "px";
}, function (_a) {
    var mt = _a.mt, theme = _a.theme;
    return mt && "margin-top: " + theme.spacing(mt) + "px";
}, function (_a) {
    var mb = _a.mb, theme = _a.theme;
    return mb && "margin-bottom: " + theme.spacing(mb) + "px";
}, function (_a) {
    var m = _a.m, theme = _a.theme;
    return m && "margin: " + theme.spacing(m) + "px";
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "opacity: 0.5;";
}, function (_a) {
    var background = _a.background;
    return background && "background: " + background + ";";
}, function (_a) {
    var opacity = _a.opacity;
    return typeof opacity === 'number' ? "opacity: " + opacity + ";" : "";
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius
        ? typeof borderRadius === 'string'
            ? borderRadius
            : borderRadius + "px"
        : '4px';
}, function (_a) {
    var hover = _a.hover;
    return (hover ? hover : '');
}, function (_a) {
    var background = _a.background;
    return background
        ? background === 'transparent'
            ? 'rgba(9, 9, 9, 0.05)'
            : polished_1.darken(0.1, background)
        : 'rgba(9, 9, 9, 0.05)';
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=MBIconButton.js.map